// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"cards_scrollbar__Sq0we"};